import { FileItem, Message } from '@arco-design/web-vue';
import { CSSProperties, PropType } from 'vue';
import globalContants from '@/constants/globalContants';

export const basicProps = {
  fileList: {
    type: Array as PropType<Record<string, any>[]>,
    default: () => [],
  },
  // 最大上传文件：默认 10m`
  maxSize: {
    type: [Number],
    default: globalContants.PICTURE_MAX_SIZE,
  },
  maxSizeTipType: {
    type: String,
    default: 'MB',
  },
  exceedLimit: {
    type: Function as PropType<(fileList: FileItem[], files: File[]) => any>,
    default: () => {
      return Message.warning('不能超过最大限制');
    },
  },
  // 最大上传数量
  limit: {
    type: [Number],
    default: globalContants.IMAGE_MAX_COUNT,
  },
  accept: {
    type: String,
    default: '*',
  },
  listType: {
    type: String as PropType<'text' | 'picture' | 'picture-card' | undefined>,
    default: 'picture-card',
  },
  // 模块标记
  // 0：默认 1：商品图片 2：商品附件 3：生产出库附件 4：生产入库附件 5：生产节点附件
  // 6：工序外发回收附件 7：生产节点审核附件 8：工序外发附件 9：新增收入附件 10：新增供应商附件
  // 11：新增客户附件 12：新增支出附件 13：新增生产单附件 14：新增物料图片 15：物料出库附件
  // 16：物料入库附件 17：物料退货附件 18：调拨单附件 19-汇报进度附件  20-成品入库附件 21-成品出库附件
  moduleFlag: {
    type: [String, Number],
    default: 0,
  },
  showUploadRemoveBtn: {
    type: Boolean,
    default: true,
  },
  imageLoading: {
    type: String as PropType<'eager' | 'lazy'>,
  },
  // 使用小尺寸
  miniSize: {
    type: Boolean,
    default: false,
  },
  // 自定义图片尺寸(图片长宽都是用imageWidth)
  imageWidth: {
    type: Number,
    default: 78,
  },
  // 上传按钮的样式，可用于从外部覆盖固定的宽高
  uploadButtonStyle: {
    type: Object as PropType<CSSProperties>,
    default: () => ({}),
  },
  // 是否显示图片标签
  showImageLabel: {
    type: Boolean,
    default: false,
  },
  imageLabelPosition: {
    type: String,
    default: 'bottom',
  },
};
type UploadStatus = 'init' | 'uploading' | 'done' | 'error';
export const STATUS: {
  [key: string]: UploadStatus;
} = {
  init: 'init',
  uploading: 'uploading',
  success: 'done',
  fail: 'error',
};
